import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'sidebar-skeleton',
    templateUrl: './sidebar-skeleton.component.html',
    styleUrls: ['./sidebar-skeleton.component.scss'],
    standalone: false
})
export class SidebarSkeletonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
}
